import React from "react";
import styles from "./VideosPage.module.css";
import newvideo from "./assets/newvideo.mp4";

const VideosPage = () => {
  const videosData = [
    {
      src: newvideo,
      youtube: false,
    },
    {
      src: "https://www.youtube.com/embed/yuMg4q8Ka8U?si=QSjqZp4fn5wuesb1",
      youtube: true,
    },
    {
      src: "https://www.youtube.com/embed/WpKNC413JsA?si=CM-eg0rOitZuYzc-",
      youtube: true,
    },
    {
      src: "https://www.youtube.com/embed/M7WQ09RU4V0?si=pTuE1Ar04834BoF2",
      youtube: true,
    },
    {
      src: "https://www.youtube.com/embed/-jgrL9jPMoE?si=qnMCNSKSD-9PhsuF",
      youtube: true,
    },
  ];
  return (
    <>
      <div className={styles.DictionaryMainContainer}>
        <h1>Videos</h1>
        <div className={styles.DictionaryContainer}>
          <div className="row">
            {videosData.map((item) => (
              <>
                {item.youtube ? (
                  <div
                    style={{ marginBottom: "40px" }}
                    className="col-12 col-lg-6"
                  >
                    <iframe
                      width="100%"
                      height="400"
                      src={item.src}
                      title="YouTube video player"
                      frameborder="0"
                      allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                      referrerpolicy="strict-origin-when-cross-origin"
                      allowfullscreen
                    ></iframe>
                  </div>
                ) : (
                  <div
                    style={{ marginBottom: "40px" }}
                    className="col-12 col-lg-6"
                  >
                    <video
                      src={item.src}
                      autoPlay
                      loop
                      muted
                      playsInline
                      preload="auto"
                      controls
                    ></video>
                  </div>
                )}
              </>
            ))}
          </div>
        </div>
      </div>
    </>
  );
};

export default VideosPage;
